<template>
    <div>
        <div class="bg">
            <div class="companyName">{{companyName}}</div>
        </div>
        <el-dialog title="在线学习系统" 
                    :visible.sync="dialogFormVisible2" 
                    top="30vh"
                    center
                    :close-on-press-escape="false" 
                    :close-on-click-modal="false"
                    :show-close="false"
                    :modal="false"
                    :width="dialogWidth"
                    class="commonDialog bindInfo">
            <el-form :model="form2" ref="form2">
                <el-form-item label="姓名" prop="name" :label-width="formLabelWidth" :rules="{required: true, message:'姓名不能为空'}">
                    <el-input v-model="form2.name" type="name" autocomplete="off" placeholder="请输入真实姓名"></el-input>
                </el-form-item>
                <el-form-item label="电话" prop="phone" :label-width="formLabelWidth" :rules="rules.phone">
                    <el-input v-model="form2.phone" type="phone" autocomplete="off" placeholder="请输入本人手机号"></el-input>
                </el-form-item>
            </el-form>
            <div class="personTip">
                <span>注：欢迎使用在线学习系统，请输入以上信息激活您的账户</span>
                <span @click="dialogFormVisible=true">注册</span>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="makeSure('form2')" class="pcBtn">确认绑定</el-button>
                <el-button @click="outLogins" class="pcBtn">退出登录</el-button>
                <el-button type="primary" @click="makeSure('form2')" size="small" class="mobileBtn">确认绑定</el-button>
                 <el-button @click="outLogins"  class="mobileBtn" size="small">退出登录</el-button>
            </div>
        </el-dialog>
        <!-- 注册弹窗 -->
        <el-dialog title="注册账号信息" 
                    :visible.sync="dialogFormVisible" 
                    center
                    top="25vh"
                    :close-on-press-escape="false" 
                    :close-on-click-modal="false"
                    :show-close="false"
                    :modal="false"
                    :width="dialogWidth"
                    class="commonDialog bindInfo">
            <el-form :model="form" ref="form" :rules="rules" :label-width="formLabelWidth">
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="form.name" type="name" autocomplete="off" placeholder="请输入真实姓名"></el-input>
                </el-form-item>
                <el-form-item label="公司" prop="company">
                    <el-select v-model="form.company" placeholder="请选择公司" @change="getDepartment($event)">
                        <el-option v-for="(item,index) in childCompany" :key="index" :label="item.departmentParentName" :value="item.departmentParentId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="部门" prop="department">
                    <el-select v-model="form.department" placeholder="请选择部门">
                        <el-option v-for="(item2,index2) in childDepartment" :key="index2" :label="item2.departmentName" :value="item2.departmentId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model="form.email" type="email" autocomplete="off" placeholder="请输入邮箱"></el-input>
                </el-form-item>
                <el-form-item label="电话" prop="phone">
                    <el-input v-model="form.phone" type="phone" autocomplete="off" placeholder="请输入本人手机号"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="register('form')" class="pcBtn">提交</el-button>
                <el-button class="pcBtn" @click="cancel()">取消</el-button>
                <el-button type="primary" @click="register('form')" size="small" class="mobileBtn">提交</el-button>
                <el-button  class="mobileBtn" size="small" @click="dialogFormVisible=false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import getUserInfo from "../../../assets/js/libs/getUserInfo";
    export default {
        data(){
            var checkphone = (rule, value, callback) => {
		      if (value == "") {
		        callback(new Error("请输入手机号"));
		      } else if (!this.isCellPhone(value)) {
		        callback(new Error("请输入正确的手机号!"));
		      } else {
		        callback();
		      }
            };
            var checkEmail = (rule, value, callback) => {
                const mailReg = /^([a-zA-Z0-9_\.\-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
                if (!value) {
                    return callback()
                }
                setTimeout(() => {
                    if (mailReg.test(value)) {
                        callback()
                    } else {
                        callback(new Error('请输入正确的邮箱格式'))
                    }
                }, 100)
            }
            return {
                dialogFormVisible:false,
                dialogFormVisible2:true,
                form: {
                    name: '',
                    phone:'',
                    company:'',
                    department:'',
                    email:''
                },
                form2: {
                    name: '',
                    phone:''
                },
                rules: {
                    phone: [
                        {required: true,validator: checkphone, trigger: 'blur'}
                    ],
                    email: [
                        {required: false,validator: checkEmail, trigger: 'blur'}
                    ],
                    name: [
                        {required: true,message: "姓名不能为空", trigger: 'blur'}
                    ],
                    company: [
                        {required: true,message: "公司不能为空", trigger: 'change'}
                    ],
                    department: [
                        {required: true,message: "部门不能为空", trigger: 'change'}
                    ],
                },

                formLabelWidth: '65px',
                dialogWidth:"30%",
                companyName:'',
                companyId:'',
                childCompany:[],
                childDepartment:[],
                flagLogin:this.$route.query.isLogin ? this.$route.query.isLogin  : ""
            }
        },
        methods:{
            makeSure(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var _this = this
                        this.$ajax({
                            url:this.$config.baseApi + "/binding/wx",
                            method:'post',
                            data:JSON.stringify({
                                'realName':_this.form2.name,
                                'mobile':_this.form2.phone,
                                'companyId':"",
                            })
                        }).then(res=>{
                            if(res.code == 1){
                                this.$message({
                                    message:res.msg,
                                    type:'success'
                                })
                                getUserInfo()
                                setTimeout(()=>{
                                    let lastLink = localStorage.getItem('link')
                                    if (lastLink && lastLink.indexOf('login') == -1) {
                                        window.location.href = lastLink;
                                    } else {
                                        this.$router.push('./index');
                                    }
                                },1000)
                            }else{
                                this.$message({
                                    message:res.msg,
                                    type:'error',
                                })
                            }
                        }).catch(err =>{
                            console.log(err)
                        })
                    } else {
                        return false;
                    }
                });
            },
            isCellPhone(val) {
                if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)) {
                    return false;
                } else {
                    return true;
                }
            },
            outLogins(){
                this.centerDialogVisible = false;
                this.$store.commit('user/outLogin');
                this.$message({
                    message :"退出成功",
                    type:'success'
                });
            },
            // 取消注册
            cancel(){
                if(this.flagLogin){
                    this.$router.go(-1)
                }else{
                    this.dialogFormVisible=false
                }
            },
            // 注册
            register(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$ajax({
                            url:this.$config.baseApi + "/account/register/add",
                            method:'post',
                            data:JSON.stringify({
                                'realName':this.form.name,
                                'mobile':this.form.phone,
                                'departmentParentId':this.form.company,
                                'departmentId':this.form.department,
                                'email':this.form.email
                            })
                        }).then(res=>{
                            if(res.code == 1){
                                this.form2.name = this.form.name;
                                this.form2.phone = this.form.phone;

                                this.$message({
                                    message:'提交注册成功，等待管理员审核',
                                    type:'success',
                                    duration:'10000'
                                })
                                setTimeout(()=>{
                                        if(!this.flagLogin){
                                        this.dialogFormVisible = false;
                                    }else{
                                        this.$router.go(-1)
                                    }
                                },1000)
                               
                            }else{
                                this.$message({
                                    message:res.msg,
                                    type:'error',
                                })
                            }
                        }).catch(err =>{
                            console.log(err)
                        })
                        // 等注册返回成功赋值
                        
                    } else {
                        return false;
                    }
                });
            },
            getCompanyName(id){
                this.$ajax({
                    url:this.$config.baseApi + "/account/company/reception/" + id,
                    method:'get'
                }).then(res=>{
                    if(res.code == 1){
                        this.companyName = res.data.companyName
                    }
                }).catch(err =>{
                    console.log(err)
                })
            },
            // 子公司
            chidrenCompany(id){
                this.$ajax({
                    url:this.$config.baseApi + "/account/department/departmentParentList/" + id,
                    method:'get'
                }).then(res=>{
                    if(res.code == 1){
                        this.childCompany = res.data
                    }
                }).catch(err =>{
                    console.log(err)
                })
            },
            // 部门
            getDepartment(id){
                console.log(id)
                this.$ajax({
                    url:this.$config.baseApi + "/account/department/departmentList/" + id,
                    method:'get'
                }).then(res=>{
                    if(res.code == 1){
                        this.childDepartment = res.data 
                    }
                }).catch(err =>{
                    console.log(err)
                })
            }
        },
        created(){
            if(this.$IsPc()){
                this.dialogWidth = "80%";
            };
            this.companyId = localStorage.getItem('linkConpanyId')
            if(this.companyId){
                this.getCompanyName(this.companyId)
                this.chidrenCompany(this.companyId)
            }else{
                this.getCompanyName(-1)
                this.chidrenCompany(-1)
            }
            console.log(this.flagLogin)
            if(this.flagLogin){
                this.dialogFormVisible = true
            }
        },
        mounted(){
            if(this.flagLogin){
                document.title="注册"
            }else{
                document.title=this.$route.meta.title
            }
        }
    }
</script>

<style scoped>
    .mobileBtn{
        display:none
    }
    .personTip{
        margin-left:0.63rem;
        text-align: left;
        font-size:0.14rem;
        display:flex;
        justify-content: space-between;
    }
    .personTip span:nth-child(2){
        color:#417ccb;
        cursor: pointer;
        width: 0.8rem;
        text-align: right;
    }
    .bg{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: url(../../../assets/images/common/qr_bg.png) no-repeat center;
        background-size: cover;
    }
    .el-select{
        width:100%;
    }
    .bg .companyName{
        font-size: 0.2rem;
        color:#fff;
        font-weight:bold;
        margin:0.6rem;

    }
    @media screen and (max-width: 768px) {
        .personTip span:nth-child(2){
            display: inline-block;
            width: 1rem;
            text-align: right;
        }
        .mobileBtn{
            display:inline-block
        }
        .pcBtn{
            display:none
        }
        .bg .companyName{
            font-size: 0.4rem;
            color:#fff;
            font-weight:bold;
            margin-top:2rem;
            text-align: center;
        }
    }
</style>
